(() => {
  const normalize=(value)=>String(value||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim().toLowerCase().replace(/[^a-z0-9]+/g,' ').replace(/\s+/g,' ');
  const mediaKey=(value)=>{const raw=String(value||'');const match=raw.match(/(\d+)(?:\D*)$/);return match?match[1]:raw;};
  const imagePath=(src)=>{try{return new URL(src,location.origin).pathname}catch(_){return String(src||'').split('?')[0]}};
  const variantMediaKey=(variant)=>mediaKey(variant?.featured_media?.id||variant?.featured_image?.id||'');
  const variantImage=(variant)=>variant?.featured_image?.src||variant?.featured_image?.url||variant?.featured_image||variant?.featured_media?.preview_image?.src||variant?.featured_media?.preview_image?.url||'';
  const parseVariants=(picker)=>{try{return JSON.parse(picker.querySelector('[data-variant-data]')?.textContent||'[]')}catch(_){return[]}};
  const selectedValues=(picker)=>[...picker.querySelectorAll('[data-option-value]:checked')].sort((a,b)=>Number(a.dataset.optionIndex)-Number(b.dataset.optionIndex)).map((input)=>input.value);
  const matchesVariant=(variant,values)=>Array.isArray(variant?.options)&&variant.options.every((value,index)=>value===values[index]);
  const getItems=(gallery)=>[...gallery.querySelectorAll('.product__media')];
  const getVisible=(gallery)=>getItems(gallery).filter((item)=>item.style.display!=='none');

  const updateGalleryControls=(gallery)=>{
    const shell=gallery.closest('[data-product-gallery-shell]');
    const controls=shell?.querySelector('[data-product-gallery-controls]');
    if(!controls)return;
    const list=getVisible(gallery);
    const current=controls.querySelector('[data-gallery-current]');
    const total=controls.querySelector('[data-gallery-total]');
    const previous=controls.querySelector('[data-gallery-previous]');
    const next=controls.querySelector('[data-gallery-next]');
    if(total)total.textContent=String(list.length||0);
    controls.hidden=list.length<=1;
    if(!list.length)return;
    const left=gallery.getBoundingClientRect().left;
    const active=list.reduce((best,item,index)=>{const distance=Math.abs(item.getBoundingClientRect().left-left);return distance<best.distance?{index,distance}:best;},{index:0,distance:Infinity}).index;
    if(current)current.textContent=String(active+1);
    if(previous)previous.disabled=active===0;
    if(next)next.disabled=active>=list.length-1;
    controls.dataset.active=String(active);
  };

  const go=(gallery,index,behavior='smooth')=>{
    const list=getVisible(gallery);
    if(!list.length)return;
    const target=list[Math.max(0,Math.min(list.length-1,index))];
    if(target)gallery.scrollTo({left:target.offsetLeft,behavior});
  };

  const initGallery=(gallery)=>{
    if(gallery.dataset.pk9GalleryInit==='true')return;
    gallery.dataset.pk9GalleryInit='true';
    const shell=gallery.closest('[data-product-gallery-shell]');
    const controls=shell?.querySelector('[data-product-gallery-controls]');
    gallery.addEventListener('scroll',()=>requestAnimationFrame(()=>updateGalleryControls(gallery)),{passive:true});
    controls?.querySelector('[data-gallery-previous]')?.addEventListener('click',()=>go(gallery,Number(controls.dataset.active||0)-1));
    controls?.querySelector('[data-gallery-next]')?.addEventListener('click',()=>go(gallery,Number(controls.dataset.active||0)+1));
    updateGalleryControls(gallery);
  };

  const syncGallery=(picker)=>{
    const gallery=picker.querySelector('[data-product-gallery]')||document.querySelector('[data-product-gallery]');
    if(!gallery)return;
    const variants=parseVariants(picker);
    const values=selectedValues(picker);
    const variant=variants.find((item)=>matchesVariant(item,values));
    if(!variant)return;

    const colorGroup=picker.querySelector('[data-color-option]');
    const colorIndex=colorGroup?Number(colorGroup.dataset.optionIndex):-1;
    const selectedColor=colorIndex>=0?normalize(values[colorIndex]):'';
    const targetKey=variantMediaKey(variant);
    const targetPath=imagePath(variantImage(variant));
    const ownersByMedia=new Map();
    const ownersByPath=new Map();

    if(colorIndex>=0){
      variants.forEach((item)=>{
        const owner=normalize(item.options?.[colorIndex]);
        const key=variantMediaKey(item);
        const path=imagePath(variantImage(item));
        if(key){if(!ownersByMedia.has(key))ownersByMedia.set(key,new Set());ownersByMedia.get(key).add(owner);}
        if(path){if(!ownersByPath.has(path))ownersByPath.set(path,new Set());ownersByPath.get(path).add(owner);}
      });
    }

    let anchor=null;
    getItems(gallery).forEach((item)=>{
      const img=item.querySelector('img');
      const key=mediaKey(item.dataset.mediaId);
      const paths=[img?.currentSrc,img?.src].filter(Boolean).map(imagePath);
      const exactKey=targetKey&&key===targetKey;
      const exactPath=targetPath&&paths.includes(targetPath);
      if(exactKey||exactPath)anchor=item;

      let belongsToOtherColor=false;
      if(selectedColor){
        const mediaOwners=ownersByMedia.get(key);
        const pathOwners=paths.map((path)=>ownersByPath.get(path)).find(Boolean);
        const owners=mediaOwners||pathOwners;
        belongsToOtherColor=Boolean(owners&&owners.size&& !owners.has(selectedColor));
      }
      item.style.display=belongsToOtherColor&&!(exactKey||exactPath)?'none':'';
    });

    if(anchor){anchor.style.display='';gallery.insertBefore(anchor,gallery.firstElementChild);}
    requestAnimationFrame(()=>{go(gallery,0,'auto');updateGalleryControls(gallery);});
  };

  const initPicker=(picker)=>{
    if(picker.dataset.pk9MediaSync==='true')return;
    picker.dataset.pk9MediaSync='true';
    const gallery=picker.querySelector('[data-product-gallery]')||document.querySelector('[data-product-gallery]');
    if(gallery)initGallery(gallery);
    syncGallery(picker);
  };

  const init=(root=document)=>{
    root.querySelectorAll('[data-product-gallery]').forEach(initGallery);
    root.querySelectorAll('[data-variant-picker]').forEach(initPicker);
  };

  document.addEventListener('change',(event)=>{
    if(!event.target.matches('[data-option-value]'))return;
    const picker=event.target.closest('[data-variant-picker]');
    if(picker)requestAnimationFrame(()=>syncGallery(picker));
  });

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});else init();
  document.addEventListener('shopify:section:load',(event)=>init(event.target));

  const primary=document.querySelector('[data-primary-purchase]');
  const sticky=document.querySelector('[data-sticky-product-bar]');
  const form=document.querySelector('[data-product-form]');
  const submit=form?.querySelector('[type="submit"]');
  const stickyButton=sticky?.querySelector('[data-sticky-add]');
  if(stickyButton&&form&&submit)stickyButton.addEventListener('click',()=>form.requestSubmit(submit));
  if(primary&&sticky){const update=()=>sticky.toggleAttribute('data-visible',matchMedia('(max-width:640px)').matches&&primary.getBoundingClientRect().bottom<0);addEventListener('scroll',update,{passive:true});addEventListener('resize',update);update();}
})();